export default {
  loginuser: '',
  setloginuser (loginuser) {
    this.loginuser = loginuser
  }
}
